import { useEffect } from 'react';

/**
 * Opens a page at its top.
 *
 * A record page replaces its list in place — the shell has no router to reset the scroll — so it
 * inherits wherever the list was scrolled to. Opening the fortieth design put its heading, its name
 * and its back arrow above the fold. Runs once, on mount: after that the scroll is the person's own.
 */
export function useOpenAtTop(): void {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);
}
